import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/store/types';
import { ChatState } from './types';
import { DeviceStatusEnum } from '@/types';
import { LocalStorageConsts } from '@/constants/localstorage';

export const state: ChatState = {
  isMeResolved: false,
  me: {
    id: '',
    firstName: '',
    lastName: '',
    userMode: '',
    paused: false,
    isAcknowledged: null,
    isAuthorized: false,
    email: '',
    token: '',
    audioDeviceStatus: DeviceStatusEnum.active,
    videoDeviceStatus: DeviceStatusEnum.active,
  },
  conversationInfo: { id: '', code: '' },
  active: undefined,
  currentMode: '',
  messages: [],
  allMessagesCount: 0,
  users: [],
  idGuestIsTyping: '',
  fontSettings: {
    size: '14',
    family: 'Roboto',
    color: '#000000',
  },
  isCameraDoubleWidth: false,
  isSignerGuideAccepted: localStorage.getItem(LocalStorageConsts.SIGNER_GUIDE_ACCEPTED) === 'true',
  isPausedRecognizing: false,
  recognitionStatus: {
    warning: '',
    launched: false,
    isActive: false,
  },
  availableModels: [],
};

const namespaced = true;

export const chat: Module<ChatState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
